"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _TwelveColumnGrid = _interopRequireDefault(require("../../components/Grid/TwelveColumnGrid/TwelveColumnGrid"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["children"],
  _excluded2 = ["variant", "children"];
var _templateObject;
var StyledColumn = (0, _styledComponents.default)(_TwelveColumnGrid.default.Item)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  "])));
var columnWidthSpecs = {
  ThreeThreeThreeThreeRatio: {
    colOneWidth: 3,
    colTwoWidth: 3,
    colThreeWidth: 3,
    colFourWidth: 3
  },
  TwelveTwelveRatio: {
    colOneWidth: 12,
    colTwoWidth: 12,
    colThreeWidth: 12,
    colFourWidth: 12
  }
};
function SingleColumn(_ref) {
  var children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var storeVar = props.variant ? columnWidthSpecs[props.variant] : columnWidthSpecs['TwelveTwelveRatio'];
  return _react.default.createElement(StyledColumn, Object.assign({
    xs: 12,
    sm: 12,
    md: storeVar["".concat(props.columnNumber, "Width")],
    lg: storeVar["".concat(props.columnNumber, "Width")],
    xl: storeVar["".concat(props.columnNumber, "Width")]
  }, props), children);
}
;
function FourColumnLayout(_ref2) {
  var variant = _ref2.variant,
    children = _ref2.children,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  var storeVar = variant ? columnWidthSpecs[variant] : columnWidthSpecs['TwelveTwelveRatio'];
  return _react.default.createElement(_TwelveColumnGrid.default, Object.assign({
    justifyContent: storeVar.colOneWidth + storeVar.colTwoWidth + storeVar.colThreeWidth < 12 ? 'space-between' : 'flex-start'
  }, props), children);
}
;
FourColumnLayout.Column = SingleColumn;
var _default = FourColumnLayout;
exports.default = _default;